import React, { useEffect, useRef, useState } from "react";
import { Pencil, Trash2, X } from "lucide-react";
import { DEFAULT_LOC, DEFAULT_PINCODE } from "./prescriptionDefaults";

const dosageOptions = [
  
  { label: "s.o.s.", value: "s.o.s." },
  { label: "q.wk.", value: "q.wk." },
  { label: "b.i.d.", value: "b.i.d." },
  { label: "t.i.d.", value: "t.i.d." },
  { label: "q.i.d.", value: "q.i.d." },
  { label: "q.h.s.", value: "q.h.s." },
  { label: "5X a day", value: "5X a day" },
  { label: "q.4h", value: "q.4h" },
  { label: "q.6h", value: "q.6h" },
  { label: "q.o.d.", value: "q.o.d." },
  { label: "prn.", value: "prn." },
  { label: "q.d.", value: "q.d." },
  { label: "I.M.", value: "I.M." },
  { label: "Subq.", value: "Subq." },
  { label: "Rectally", value: "Rectally" },
  { label: "I.V.", value: "I.V." },
  { label: "O.D.", value: "O.D." },
  { label: "O.S.", value: "O.S." },
  { label: "O.U.", value: "O.U." },
  { label: "2 ml", value: "2 ml" },
  { label: "2.5 ml", value: "2.5 ml" },
  { label: "5 ml", value: "5 ml" },
  { label: "10 ml", value: "10 ml" },
]
 

// const frequencyOptions = [
//   { label: "0-0-1", value: "0-0-1" },
//   { label: "0-1-1", value: "0-1-1" },
//   { label: "0-1-0", value: "0-1-0" },
//   { label: "1-1-1", value: "1-1-1" },
//   { label: "1-0-0", value: "1-0-0" },
//   { label: "1-0-1", value: "1-0-1" },
//   { label: "1-1-0", value: "1-1-0" },
//   { label: "1-1-1-1", value: "1-1-1-1" },
//   { label: "1-0-0-0", value: "1-0-0-0" },
//   { label: "1-1-0-0", value: "1-1-0-0" },
//   { label: "1-1-1-0", value: "1-1-1-0" },
//   { label: "0-0-0-1", value: "0-0-0-1" },
//   { label: "0-0-1-1", value: "0-0-1-1" },
//   { label: "0-0-1-0", value: "0-0-1-0" },
//   { label: "0-1-0-0", value: "0-1-0-0" },
//   { label: "0-1-1-1", value: "0-1-1-1" },
//   { label: "1-0-0-1", value: "1-0-0-1" },
//   { label: "1-0-1-0", value: "1-0-1-0" },
//   { label: "1-0-1-1", value: "1-0-1-1" },
//   { label: "1-1-0-1", value: "1-1-0-1" },
//   { label: "0-1-0-1", value: "0-1-0-1" },
//   { label: "0-1-1-0", value: "0-1-1-0" },
// ];
const frequencyOptions = [
  { label: "0-0-0-1", value: "0-0-0-1" },
  { label: "0-0-1-0", value: "0-0-1-0" },
  { label: "0-0-1-1", value: "0-0-1-1" },
 
  { label: "0-1-0-0", value: "0-1-0-0" },
  { label: "0-1-0-1", value: "0-1-0-1" },
  { label: "0-1-1-0", value: "0-1-1-0" },
  { label: "0-1-1-1", value: "0-1-1-1" },
 
  { label: "1-0-0-0", value: "1-0-0-0" },
  { label: "1-0-0-1", value: "1-0-0-1" },
  { label: "1-0-1-0", value: "1-0-1-0" },
  { label: "1-0-1-1", value: "1-0-1-1" },
 
  { label: "1-1-0-0", value: "1-1-0-0" },
  { label: "1-1-0-1", value: "1-1-0-1" },
  { label: "1-1-1-0", value: "1-1-1-0" },
  { label: "1-1-1-1", value: "1-1-1-1" },
];
const instructionOptions = [
  { label: "None", value: "2" },
  { label: "After Meal", value: "0" },
  { label: "Before Meal", value: "1" },
];

const getInstructionLabel = (value) => {
  if (value === undefined || value === null || value === "") return "-";
  const match = instructionOptions.find(
    (option) => option.value === String(value).trim()
  );
  return match?.label || String(value);
};


const sanitizeQuantityValue = (value) => {
  const digitsOnly = String(value ?? "").replace(/\D/g, "");
  if (!digitsOnly) return "";
  return digitsOnly.replace(/^0+/, "");
};

const initialAddForm = {
  medicineName: "",
  composition: "",
  drugCategory: "",
  drugCode: "",
  itemCode: "",
  preferredMedicine: "",
  quantity: "",
  frequency: "",
  dosage: "",
  noOfDays: "",
  instruction: "",
  notes: "",
};

const EditPrescriptionMedicineTab = ({
  medicineItems,
  setMedicineItems,
  pincode = "",
  state = "",
}) => {
  const MEDICINE_SEARCH_API = `${process.env.REACT_APP_API_ES_V3_URL}medicine/pincode`;
  const medicineSearchPincode = pincode || DEFAULT_PINCODE;
  const medicineSearchLoc = String(state || DEFAULT_LOC).toLowerCase();
  const [rows, setRows] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editForm, setEditForm] = useState({
    medicineName: "",
    composition: "",
    drugCategory: "",
    drugCode: "",
    itemCode: "",
    preferredMedicine: "",
    quantity: "",
    dosage: "",
    frequency: "",
    noOfDays: "",
    instruction: "",
    notes: "",
  });
  const [medicineSuggestions, setMedicineSuggestions] = useState([]);
  const [loadingMedicineSuggestions, setLoadingMedicineSuggestions] =
    useState(false);
  const [showMedicineSuggestions, setShowMedicineSuggestions] = useState(false);
  const [addMedicineSuggestions, setAddMedicineSuggestions] = useState([]);
  const [loadingAddMedicineSuggestions, setLoadingAddMedicineSuggestions] =
    useState(false);
  const [showAddMedicineSuggestions, setShowAddMedicineSuggestions] =
    useState(false);
  const [isAddMedicineOpen, setIsAddMedicineOpen] = useState(false);
  const [addForm, setAddForm] = useState(initialAddForm);
  const [addFormErrors, setAddFormErrors] = useState({});
  const suppressNextSearchRef = useRef(false);
  const suppressNextAddSearchRef = useRef(false);
  const medicineNameInputRef = useRef(null);
  const addMedicineNameInputRef = useRef(null);

  useEffect(() => {
    setRows(Array.isArray(medicineItems) ? medicineItems : []);
  }, [medicineItems]);

  const openEdit = (med, index) => {
    setEditingIndex(index);
    setEditForm({
      medicineName: med?.drugName || med?.medicineName || med?.name || "",
      composition: med?.composition || "",
      drugCategory: med?.drugCategory || med?.category || "",
      drugCode: med?.drugCode || "",
      itemCode: med?.itemCode || "",
      preferredMedicine: med?.preferredMedicine || "",
      quantity:
        med?.quantity !== undefined && med?.quantity !== null
          ? String(med?.quantity)
          : med?.qty !== undefined && med?.qty !== null
            ? String(med?.qty)
            : "",
      dosage: med?.dosage || "",
      frequency: med?.frequency || "",
      noOfDays: med?.duration || med?.noOfDays || med?.days || "",
      instruction: med?.instruction || "",
      notes: med?.notes || "",
    });
  };

  const closeEdit = () => {
    setEditingIndex(null);
    setShowMedicineSuggestions(false);
    setMedicineSuggestions([]);
  };

  useEffect(() => {
    if (editingIndex === null) return;

    if (suppressNextSearchRef.current) {
      suppressNextSearchRef.current = false;
      return;
    }

    const searchText = String(editForm.medicineName || "").trim();
    if (searchText.length < 3) {
      setMedicineSuggestions([]);
      setShowMedicineSuggestions(false);
      return;
    }

    const controller = new AbortController();
    const timer = setTimeout(async () => {
      try {
        setLoadingMedicineSuggestions(true);
        const response = await fetch(
          `${MEDICINE_SEARCH_API}?pageNo=1&pageSize=10&pincode=${encodeURIComponent(
            medicineSearchPincode
          )}&loc=${encodeURIComponent(medicineSearchLoc)}&freeTextSearch=${encodeURIComponent(
            searchText
          )}`,
          {
            method: "GET",
          }
        );

        if (!response.ok) {
          throw new Error(`Medicine search failed with ${response.status}`);
        }

        const data = await response.json();
        const list = Array.isArray(data?.data)
          ? data.data
          : Array.isArray(data?.content)
          ? data.content
          : Array.isArray(data)
          ? data
          : [];
        setMedicineSuggestions(list);
      } catch (error) {
        if (error?.name !== "AbortError") {
          setMedicineSuggestions([]);
          setShowMedicineSuggestions(false);
        }
      } finally {
        setLoadingMedicineSuggestions(false);
      }
    }, 300);

    return () => {
      clearTimeout(timer);
      controller.abort();
    };
  }, [MEDICINE_SEARCH_API, editForm.medicineName, editingIndex, medicineSearchPincode, medicineSearchLoc]);

  useEffect(() => {
    if (!isAddMedicineOpen) return;

    if (suppressNextAddSearchRef.current) {
      suppressNextAddSearchRef.current = false;
      return;
    }

    const searchText = String(addForm.medicineName || "").trim();
    if (searchText.length < 3) {
      setAddMedicineSuggestions([]);
      setShowAddMedicineSuggestions(false);
      return;
    }

    const controller = new AbortController();
    const timer = setTimeout(async () => {
      try {
        setLoadingAddMedicineSuggestions(true);
        const response = await fetch(
          `${MEDICINE_SEARCH_API}?pageNo=1&pageSize=10&pincode=${encodeURIComponent(
            medicineSearchPincode
          )}&loc=${encodeURIComponent(medicineSearchLoc)}&freeTextSearch=${encodeURIComponent(
            searchText
          )}`,
          {
            method: "GET",
          }
        );

        if (!response.ok) {
          throw new Error(`Medicine search failed with ${response.status}`);
        }

        const data = await response.json();
        const list = Array.isArray(data?.data)
          ? data.data
          : Array.isArray(data?.content)
          ? data.content
          : Array.isArray(data)
          ? data
          : [];
        setAddMedicineSuggestions(list);
        setShowAddMedicineSuggestions(true);
      } catch (error) {
        if (error?.name !== "AbortError") {
          setAddMedicineSuggestions([]);
          setShowAddMedicineSuggestions(false);
        }
      } finally {
        setLoadingAddMedicineSuggestions(false);
      }
    }, 300);

    return () => {
      clearTimeout(timer);
      controller.abort();
    };
  }, [MEDICINE_SEARCH_API, addForm.medicineName, isAddMedicineOpen, medicineSearchPincode, medicineSearchLoc]);

  const getSuggestionName = (item) =>
    item?.medicineName ||
    item?.drugName ||
    item?.itemName ||
    item?.name ||
    item?.productName ||
    "";

  const getSuggestionComposition = (item) =>
    item?.composition || item?.genericName || item?.saltName || "";
   const getSuggestionDrugcode = (item) =>
    item?.id || "";

  const getSuggestionDrugCategory = (item) =>
    item?.drugCategory ||
    item?.categoryName ||
    item?.category ||
    item?.drugType ||
    "";

  const getSuggestionManufacturer = (item) =>
    item?.manufacturerName || item?.companyName || item?.manufacturer || "";

  const getSuggestionPreferredMedicine = (item) =>
    item?.preferredMedicine  || "";

  const handleSelectMedicineSuggestion = (item) => {
    console.log(item,"fcgvhbjkn")
    suppressNextSearchRef.current = true;
    setEditForm((prev) => ({
      ...prev,
      medicineName: getSuggestionName(item) || prev.medicineName,
      composition: getSuggestionComposition(item) || prev.composition,
        drugCode: getSuggestionDrugcode(item) || prev.drugCode,
      drugCategory: getSuggestionDrugCategory(item) || prev.drugCategory,
      preferredMedicine:
        getSuggestionPreferredMedicine(item) || prev.preferredMedicine,
    }));
    setShowMedicineSuggestions(false);
    if (medicineNameInputRef.current) {
      medicineNameInputRef.current.blur();
    }
  };

  const handleSelectAddMedicineSuggestion = (item) => {
    suppressNextAddSearchRef.current = true;
    setAddForm((prev) => ({
      ...prev,
      medicineName: getSuggestionName(item) || prev.medicineName,
      composition: getSuggestionComposition(item) || prev.composition,
       drugCode: getSuggestionDrugcode(item) || prev.drugCode,
      drugCategory: getSuggestionDrugCategory(item) || prev.drugCategory,
      preferredMedicine:
        getSuggestionPreferredMedicine(item) || prev.preferredMedicine,
    }));
    setShowAddMedicineSuggestions(false);
    if (addMedicineNameInputRef.current) {
      addMedicineNameInputRef.current.blur();
    }
  };

  const handleUpdate = () => {
    if (editingIndex === null) return;

    setRows((prev) => {
      const updatedRows = prev.map((item, idx) =>
        idx === editingIndex
          ? {
              ...item,
              drugName: editForm.medicineName,
              drugCode: editForm.drugCode,
              itemCode: editForm.itemCode,
              medicineName: editForm.medicineName,
              name: editForm.medicineName,
              composition: editForm.composition,
              drugCategory: editForm.drugCategory,
              preferredMedicine: editForm.preferredMedicine,
              quantity: editForm.quantity,
              qty: editForm.quantity,
              dosage: editForm.dosage,
              frequency: editForm.frequency,
              duration: editForm.noOfDays,
              noOfDays: editForm.noOfDays,
              instruction: editForm.instruction,
              notes: editForm.notes,
            }
          : item
      );
      if (typeof setMedicineItems === "function") {
        setMedicineItems(updatedRows);
        console.log(updatedRows,"updatedRows")
      }
      return updatedRows;
    });

    closeEdit();
  };

  const handleAddMedicine = () => {
    console.log(addForm,"rtdfyguhij")
    const errors = {};
    if (!String(addForm.medicineName || "").trim()) {
      errors.medicineName = "Medicine Name is required";
    }
    if (!String(addForm.quantity || "").trim()) {
      errors.quantity = "Quantity is required";
    }
    if (!String(addForm.frequency || "").trim()) {
      errors.frequency = "Frequency is required";
    }
    if (!String(addForm.noOfDays || "").trim()) {
      errors.noOfDays = "No. of Days is required";
    }
    if (!String(addForm.instruction || "").trim()) {
      errors.instruction = "Instruction is required";
    }
    setAddFormErrors(errors);
    if (Object.keys(errors).length > 0) return;

    const newRow = {
      id: `new-${Date.now()}`,
      drugName: addForm.medicineName.trim(),
      drugCode: addForm.drugCode || "",
      itemCode: addForm.itemCode || "",
      medicineName: addForm.medicineName.trim(),
      name: addForm.medicineName.trim(),
      composition: addForm.composition,
      drugCategory: addForm.drugCategory,
      preferredMedicine: addForm.preferredMedicine,
      quantity: addForm.quantity,
      qty: addForm.quantity,
      dosage: addForm.dosage,
      frequency: addForm.frequency,
      duration: addForm.noOfDays,
      noOfDays: addForm.noOfDays,
      instruction: addForm.instruction,
      notes: addForm.notes,
    };

    setRows((prev) => {
      const updatedRows = [...prev, newRow];
      if (typeof setMedicineItems === "function") {
        setMedicineItems(updatedRows);
      }
      return updatedRows;
    });
    setAddForm(initialAddForm);
    setAddFormErrors({});
    setAddMedicineSuggestions([]);
    setShowAddMedicineSuggestions(false);
    setIsAddMedicineOpen(false);
  };

  const handleRemoveMedicine = (indexToRemove) => {
    setRows((prev) => {
      const updatedRows = (prev || []).filter((_, idx) => idx !== indexToRemove);
      if (typeof setMedicineItems === "function") {
        setMedicineItems(updatedRows);
      }
      return updatedRows;
    });

    if (editingIndex === indexToRemove) {
      closeEdit();
    }
  };

  const handleOpenAddMedicine = () => {
    setAddFormErrors({});
    setIsAddMedicineOpen(true);
  };

  const handleCloseAddMedicine = () => {
    setAddForm(initialAddForm);
    setAddFormErrors({});
    setAddMedicineSuggestions([]);
    setShowAddMedicineSuggestions(false);
    setIsAddMedicineOpen(false);
  };

  return (
    <div className="space-y-3">
      {rows?.length ? (
        rows.map((med, index) => (
          <div
            key={`${med?.id || med?.drugCode || med?.drugName || "medicine"}-${index}`}
            className="rounded-md border border-slate-200 p-3"
          >
            <div className="mb-2 flex items-center justify-between">
              <p className="font-semibold text-slate-700 mb-1">
                {med?.drugName || med?.medicineName || med?.name || "Medicine"}
              </p>
              <div className="flex items-center gap-2 text-slate-400">
                <button type="button" onClick={() => openEdit(med, index)}>
                  <Pencil size={14} />
                </button>
                <button
                  type="button"
                  onClick={() => handleRemoveMedicine(index)}
                  aria-label="Remove medicine"
                  className="rounded p-1 text-rose-600 transition-colors hover:bg-rose-50 hover:text-rose-700"
                >
                  <Trash2 size={14} />
                </button>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-2 text-sm text-slate-700 md:grid-cols-5">
              <div>
                <p className="text-sm text-slate-500 mb-1">Dosage</p>
                <p>{med?.dosage ||  "-"}</p>
              </div>
              <div>
                <p className="text-sm text-slate-500 mb-1">Frequency</p>
                <p>{med?.frequency || "-"}</p>
              </div>
              <div>
                <p className="text-sm text-slate-500 mb-1">Instruction</p>
                <p>{getInstructionLabel(med?.instruction ?? med?.afterBeforeFood)}</p>
              </div>
              <div>
                <p className="text-sm text-slate-500 mb-1">No. of Days</p>
                <p>{med?.duration || med?.noOfDays || med?.days || "-"}</p>
              </div>
              <div>
                <p className="text-sm text-slate-500 mb-1">Quantity</p>
                <p>
                  {med?.quantity !== undefined && med?.quantity !== null
                    ? String(med?.quantity)
                    : med?.qty !== undefined && med?.qty !== null
                      ? String(med?.qty)
                      : "-"}
                </p>
              </div>
            </div>

            {editingIndex === index ? (
              <div className="relative mt-3 rounded-md border border-sky-100 bg-sky-50/40 p-3">
                <div className="mb-3 flex items-center justify-between">
                  <h4 className="text-sm font-semibold text-slate-700">
                    Edit Medicine
                  </h4>
                  <button type="button" onClick={closeEdit}>
                    <X size={16} className="text-slate-500" />
                  </button>
                </div>

                {loadingMedicineSuggestions ? (
                  <div className="absolute inset-0 z-30 flex flex-col items-center justify-center rounded-md bg-white/70 backdrop-blur-[1px]">
                    <div className="h-10 w-10 animate-spin rounded-full border-4 border-slate-300 border-t-blue-600" />
                    <p className="mt-2 text-sm font-medium text-slate-600">
                      Loading
                    </p>
                  </div>
                ) : null}

                <div className="grid grid-cols-1 gap-3 md:grid-cols-4">
                  <div className="relative">
                    <div className="mb-1 flex items-center justify-between">
                      <label className="block text-xs text-slate-600">
                        Medicine Name
                      </label>
                    </div>
                    <input
                      ref={medicineNameInputRef}
                      value={editForm.medicineName}
                      onChange={(e) => {
                        setEditForm((prev) => ({
                          ...prev,
                          medicineName: e.target.value,
                        }));
                        setShowMedicineSuggestions(true);
                      }}
                      className="w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
                      onFocus={() => {
                        if (medicineSuggestions.length > 0) {
                          setShowMedicineSuggestions(true);
                        }
                      }}
                      onBlur={() => {
                        setTimeout(() => setShowMedicineSuggestions(false), 120);
                      }}
                    />
                    {showMedicineSuggestions ? (
                      <div className="absolute z-20 mt-1 max-h-56 w-full overflow-auto rounded-md border border-slate-200 bg-white shadow-lg">
                        {loadingMedicineSuggestions ? (
                          <div className="px-3 py-2 text-sm text-slate-500">
                            Searching medicine...
                          </div>
                        ) : medicineSuggestions.length ? (
                          <>
                            {medicineSuggestions.map((item, idx) => (
                              <button
                                key={`medicine-suggestion-${idx}`}
                                type="button"
                                className="w-full border-b border-slate-100 px-3 py-2 text-left last:border-b-0 hover:bg-slate-50"
                                onMouseDown={(e) => {
                                  e.preventDefault();
                                  handleSelectMedicineSuggestion(item);
                                }}
                              >
                                <div className="text-sm font-medium text-slate-800">
                                  {getSuggestionName(item)}
                                </div>
                                {getSuggestionComposition(item) ? (
                                  <div className="text-xs text-slate-500">
                                    {getSuggestionComposition(item)}
                                  </div>
                                ) : null}
                                {getSuggestionManufacturer(item) ? (
                                  <div className="text-xs text-slate-400">
                                    {getSuggestionManufacturer(item)}
                                  </div>
                                ) : null}
                              </button>
                            ))}
                            <button
                              type="button"
                              className="w-full border-t border-slate-100 px-3 py-2 text-left text-sm font-medium text-blue-600 hover:bg-blue-50"
                              onMouseDown={(e) => {
                                e.preventDefault();
                                suppressNextSearchRef.current = true;
                                setEditForm((prev) => ({ ...prev, medicineName: editForm.medicineName }));
                                setShowMedicineSuggestions(false);
                              }}
                            >
                              + Add "{editForm.medicineName}" manually
                            </button>
                          </>
                        ) : (
                          <div className="px-3 py-2 text-sm text-slate-500">
                            No medicines found.{" "}
                            <button
                              type="button"
                              className="font-medium text-blue-600 hover:underline"
                              onMouseDown={(e) => {
                                e.preventDefault();
                                suppressNextSearchRef.current = true;
                                setShowMedicineSuggestions(false);
                              }}
                            >
                              Add "{editForm.medicineName}" manually
                            </button>
                          </div>
                        )}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label className="mb-1 block text-xs text-slate-600">
                      Composition
                    </label>
                    <input
                      value={editForm.composition}
                      onChange={(e) =>
                        setEditForm((prev) => ({
                          ...prev,
                          composition: e.target.value,
                        }))
                      }
                      className="w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
                    />
                  </div>
                  {/* <div>
                    <label className="mb-1 block text-xs text-slate-600">
                      Drug Category
                    </label>
                    <input
                      value={editForm.drugCategory}
                      onChange={(e) =>
                        setEditForm((prev) => ({
                          ...prev,
                          drugCategory: e.target.value,
                        }))
                      }
                      className="w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
                    />
                  </div> */}
                  <div>
                    <label className="mb-1 block text-xs text-slate-600">
                      Quantity
                    </label>
                    <input
                      value={editForm.quantity}
                      onChange={(e) =>
                        setEditForm((prev) => ({
                          ...prev,
                          quantity: sanitizeQuantityValue(e.target.value),
                        }))
                      }
                      inputMode="numeric"
                      placeholder="Enter quantity"
                      className="w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
                    />
                  </div>
                  <div>
                    <label className="mb-1 block text-xs text-slate-600">
                      Dosage
                    </label>
                    <select
                      value={editForm.dosage}
                      onChange={(e) =>
                        setEditForm((prev) => ({
                          ...prev,
                          dosage: e.target.value,
                        }))
                      }
                      className="w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
                    >
                      <option value="">Select dosage</option>
                      {dosageOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="mb-1 block text-xs text-slate-600">
                      Frequency
                    </label>
                    <select
                      value={editForm.frequency}
                      onChange={(e) =>
                        setEditForm((prev) => ({
                          ...prev,
                          frequency: e.target.value,
                        }))
                      }
                      className="w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
                    >
                      <option value="">Select frequency</option>
                      {frequencyOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="mb-1 block text-xs text-slate-600">
                      No. of Days
                    </label>
                    <input
                      type="number"
                      min="1"
                      value={editForm.noOfDays}
                      onChange={(e) =>
                        setEditForm((prev) => ({
                          ...prev,
                          noOfDays: e.target.value,
                        }))
                      }
                      placeholder="Enter days"
                      className="w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
                    />
                  </div>
                  <div>
                    <label className="mb-1 block text-xs text-slate-600">
                      Instruction
                    </label>
                    <select
                      value={editForm.instruction}
                      onChange={(e) =>
                        setEditForm((prev) => ({
                          ...prev,
                          instruction: e.target.value,
                        }))
                      }
                      className="w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
                    >
                      <option value="">Select instruction</option>
                      {instructionOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="mb-1 block text-xs text-slate-600">Notes</label>
                    <input
                      value={editForm.notes}
                      onChange={(e) =>
                        setEditForm((prev) => ({
                          ...prev,
                          notes: e.target.value,
                        }))
                      }
                      className="w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
                    />
                  </div>
                </div>

                <div className="mt-3 flex justify-end">
                  <button
                    type="button"
                    onClick={handleUpdate}
                    className="rounded-md bg-blue-600 px-4 py-1.5 text-sm font-medium text-white hover:bg-blue-700"
                  >
                    Update
                  </button>
                </div>
              </div>
            ) : null}
          </div>
        ))
      ) : (
        <p className="text-sm text-slate-400">No medicines available.</p>
      )}
      <div className="text-right">
        <button
          type="button"
          onClick={handleOpenAddMedicine}
          className="text-sm font-medium text-[#4b78c2]"
        >
          +Add more
        </button>
      </div>

      {isAddMedicineOpen ? (
        <div className="rounded-md border border-sky-100 bg-sky-50/40 p-3">
          <div className="mb-3 flex items-center justify-between">
            <h4 className="text-sm font-semibold text-slate-700">Add Medicine</h4>
            <button type="button" onClick={handleCloseAddMedicine}>
              <X size={16} className="text-slate-500" />
            </button>
          </div>

          <div className="grid grid-cols-1 gap-3 md:grid-cols-4">
            <div className="relative">
              <label className="mb-1 block text-xs text-slate-600">Medicine Name *</label>
              <input
                ref={addMedicineNameInputRef}
                value={addForm.medicineName}
                onChange={(e) =>
                  setAddForm((prev) => ({ ...prev, medicineName: e.target.value }))
                }
                onFocus={() => {
                  if (addMedicineSuggestions.length > 0) {
                    setShowAddMedicineSuggestions(true);
                  }
                }}
                onBlur={() => {
                  setTimeout(() => setShowAddMedicineSuggestions(false), 120);
                }}
                placeholder="Select or type to search"
                className="w-full rounded-md border border-slate-200 px-3 py-2 pr-10 text-sm"
              />
              {addFormErrors.medicineName ? (
                <p className="mt-1 text-xs text-red-600">{addFormErrors.medicineName}</p>
              ) : null}
              {loadingAddMedicineSuggestions ? (
                <div className="pointer-events-none absolute right-3 top-[34px] h-4 w-4 animate-spin rounded-full border-2 border-slate-300 border-t-blue-600" />
              ) : null}
              {showAddMedicineSuggestions ? (
                <div className="absolute z-20 mt-1 max-h-56 w-full overflow-auto rounded-md border border-slate-200 bg-white shadow-lg">
                  {loadingAddMedicineSuggestions ? (
                    <div className="px-3 py-2 text-sm text-slate-500">
                      Searching medicine...
                    </div>
                  ) : addMedicineSuggestions.length ? (
                    <>
                      {addMedicineSuggestions.map((item, idx) => (
                        <button
                          key={`add-medicine-suggestion-${idx}`}
                          type="button"
                          className="w-full border-b border-slate-100 px-3 py-2 text-left last:border-b-0 hover:bg-slate-50"
                          onMouseDown={(e) => {
                            e.preventDefault();
                            handleSelectAddMedicineSuggestion(item);
                          }}
                        >
                          <div className="text-sm font-medium text-slate-800">
                            {getSuggestionName(item)}
                          </div>
                          {getSuggestionComposition(item) ? (
                            <div className="text-xs text-slate-500">
                              {getSuggestionComposition(item)}
                            </div>
                          ) : null}
                          {getSuggestionManufacturer(item) ? (
                            <div className="text-xs text-slate-400">
                              {getSuggestionManufacturer(item)}
                            </div>
                          ) : null}
                        </button>
                      ))}
                      <button
                        type="button"
                        className="w-full border-t border-slate-100 px-3 py-2 text-left text-sm font-medium text-blue-600 hover:bg-blue-50"
                        onMouseDown={(e) => {
                          e.preventDefault();
                          suppressNextAddSearchRef.current = true;
                          setShowAddMedicineSuggestions(false);
                        }}
                      >
                        + Add "{addForm.medicineName}" manually
                      </button>
                    </>
                  ) : (
                    <div className="px-3 py-2 text-sm text-slate-500">
                      No medicines found.{" "}
                      <button
                        type="button"
                        className="font-medium text-blue-600 hover:underline"
                        onMouseDown={(e) => {
                          e.preventDefault();
                          suppressNextAddSearchRef.current = true;
                          setShowAddMedicineSuggestions(false);
                        }}
                      >
                        Add "{addForm.medicineName}" manually
                      </button>
                    </div>
                  )}
                </div>
              ) : null}
            </div>
            <div>
              <label className="mb-1 block text-xs text-slate-600">Composition</label>
              <input
                value={addForm.composition}
                onChange={(e) =>
                  setAddForm((prev) => ({ ...prev, composition: e.target.value }))
                }
                placeholder="Auto-filled or type manually"
                className="w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
              />
            </div>
            {/* <div>
              <label className="mb-1 block text-xs text-slate-600">
                Drug Category
              </label>
              <input
                value={addForm.drugCategory}
                onChange={(e) =>
                  setAddForm((prev) => ({
                    ...prev,
                    drugCategory: e.target.value,
                  }))
                }
                className="w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
              />
            </div> */}
            <div>
              <label className="mb-1 block text-xs text-slate-600">Quantity *</label>
              <input
                value={addForm.quantity}
                onChange={(e) =>
                  setAddForm((prev) => ({
                    ...prev,
                    quantity: sanitizeQuantityValue(e.target.value),
                  }))
                }
                inputMode="numeric"
                placeholder="Enter quantity"
                className="w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
              />
              {addFormErrors.quantity ? (
                <p className="mt-1 text-xs text-red-600">{addFormErrors.quantity}</p>
              ) : null}
            </div>
            <div>
              <label className="mb-1 block text-xs text-slate-600">Frequency *</label>
              <select
                value={addForm.frequency}
                onChange={(e) =>
                  setAddForm((prev) => ({ ...prev, frequency: e.target.value }))
                }
                className="w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
              >
                <option value="">Select frequency</option>
                {frequencyOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {addFormErrors.frequency ? (
                <p className="mt-1 text-xs text-red-600">{addFormErrors.frequency}</p>
              ) : null}
            </div>
            <div>
              <label className="mb-1 block text-xs text-slate-600">Dosage</label>
              <select
                value={addForm.dosage}
                onChange={(e) =>
                  setAddForm((prev) => ({ ...prev, dosage: e.target.value }))
                }
                className="w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
              >
                <option value="">Select dosage</option>
                {dosageOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="mb-1 block text-xs text-slate-600">No. of Days *</label>
              <input
                type="number"
                min="1"
                value={addForm.noOfDays}
                onChange={(e) =>
                  setAddForm((prev) => ({ ...prev, noOfDays: e.target.value }))
                }
                placeholder="Enter days"
                className="w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
              />
              {addFormErrors.noOfDays ? (
                <p className="mt-1 text-xs text-red-600">{addFormErrors.noOfDays}</p>
              ) : null}
            </div>
            <div>
              <label className="mb-1 block text-xs text-slate-600">Instruction *</label>
              <select
                value={addForm.instruction}
                onChange={(e) =>
                  setAddForm((prev) => ({ ...prev, instruction: e.target.value }))
                }
                className="w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
              >
                <option value="">Select instruction</option>
                {instructionOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {addFormErrors.instruction ? (
                <p className="mt-1 text-xs text-red-600">{addFormErrors.instruction}</p>
              ) : null}
            </div>
            <div>
              <label className="mb-1 block text-xs text-slate-600">Notes</label>
              <input
                value={addForm.notes}
                onChange={(e) =>
                  setAddForm((prev) => ({ ...prev, notes: e.target.value }))
                }
                placeholder="Enter notes"
                className="w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
              />
            </div>
          </div>

          <div className="mt-3 flex justify-end">
            <button
              type="button"
              onClick={handleAddMedicine}
              className="rounded-md bg-blue-600 px-4 py-1.5 text-sm font-medium text-white hover:bg-blue-700"
            >
              Add
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default EditPrescriptionMedicineTab;

